import { calculateShelfLife } from '@/Helpers';

/* eslint-disable*/
function QualityInfo(props) {
	const { details, handleSave, handleReject, level } = props;
	return (
		<div className='p-6'>
			<div className='flex gap-4 items-center justify-between align-center'>
				<div className='flex gap-5 items-center align-center'>
					<h2 className='text-xl font-semibold'>
						{details?.productName}
					</h2>
					{!details?.qualityCheckPresent && (
						<span className='text-orange-400 font-bold'>QC Not Configured</span>
					)}
					{details?.sampleQuantity ? (
						<span className='text-gray-600'>
							Sample Quantity:{' '}
							<strong>
								{details?.sampleQuantity
									? `${details?.sampleQuantity} %`
									: '-'}
							</strong>
							{details?.sampleQuantity
								? `(Quantity: ${details?.quantity
									? `${details?.quantity} ${details?.unit}`
									: '-'
								})`
								: null}
						</span>
					): null}
				</div>
				{details?.status === 'QC_APPROVAL_PENDING' && level > 2 && (
					<div className='flex gap-2'>
						<button
							className='bg-red-600   p-2 text-white px-4 py-2 rounded-md'
							onClick={handleReject}
						>
							Reject Qc
						</button>
						<button
							className='bg-green-600 p-2 text-white px-4 py-2 rounded-md'
							onClick={handleSave}
						>
							Pass Qc
						</button>
					</div>
				)}
			</div>

			<div className='grid grid-cols-4 gap-4 mt-4 text-gray-700'>
				<div>
					<p className='text-[12px] font-medium'>GRN ID</p>
					<p className='font-semibold text-[14px]'>{details?.grnId}</p>
				</div>
				{details?.vendorName &&
					(<div>
						<p className='text-[12px] font-medium'>Vendor Name</p>
						<p className='font-semibold text-[14px]'>{details?.vendorName}</p>
					</div>)
				}
				<div>
					<p className='text-[12px] font-medium'>Store Name</p>
					<p className='font-semibold text-[14px]'>{details?.storeName}</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>Approval Status</p>
					<div>
						<p
							className={`font-semibold text-[14px] ${details?.status === 'GRN'
									? details?.overrideUser
										? 'text-blue-600'
										: 'text-green-600'
									: details?.status === 'QC_APPROVAL_PENDING'
										? 'text-orange-600'
										: details?.status === 'QC_PENDING'
											? 'text-blue-600'
											: 'text-red-600'
								}`}
						>
							{details?.status === 'GRN'
								? details?.overrideUser
									? 'Overridden Passed'
									: 'Pass'
								: details?.status === 'QC_APPROVAL_PENDING'
									? 'Approval Pending'
									: details?.status === 'QC_PENDING'
										? 'Pending'
										: 'Fail'}
						</p>
						<div className='text-[12px]'>
							{details?.overrideUser
								? 'By ' + details?.overrideUser
								: ''}
						</div>
					</div>
				</div>
				<div>
					<p className='text-[12px] font-medium'>PO ID</p>
					<p className='font-semibold text-[14px]'>{details?.clientPoId}</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>Batch Name</p>
					<p className='font-semibold text-[14px]'>{details?.batchName}</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>Completion Date</p>
					<p className='font-semibold text-[14px]'>{details?.completionDate}</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>Batch Quantity</p>
					<p className='font-semibold text-[14px]'>{details?.batchQuantity}</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>
						Shelf life at Inwarding
					</p>
					<p className='font-semibold text-[14px]'>
						{calculateShelfLife(
							details?.manufactureDate,
							details?.expiryDate
						)}
						%
					</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>Manufacturing Date</p>
					<p className='font-semibold text-[14px]'>{details?.manufactureDate}</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>Expiry Date</p>
					<p className='font-semibold text-[14px]'>{details?.expiryDate}</p>
				</div>
				<div>
					<p className='text-[12px] font-medium'>Quantity per pack</p>
					<p className='font-semibold text-[14px]'>{details?.quantityPerUnit}</p>
				</div>
			</div>
		</div>
	);
}

export default QualityInfo;
